export const errorMessages = {
  SPACE_CODE_ERROR:
    'This code is invalid. Please check the code and try again.',
  SIGNUP_ERROR: 'There was an error processing your request. Please try again.',
};
